import React from 'react';

const Loader = () => (
  <div className="load">
    <div />
    <div />
    <div />
    <div />
  </div>
);

export default Loader;
